import React from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

/**
 * Barra de filtros del tablero.
 *
 * Píldoras de período + selectores de país, departamento y ciudad, en una
 * sola línea que se envuelve.
 *
 * OJO: los tres selectores sí viajan a los endpoints (countryId, province,
 * city). Las píldoras de período sólo guardan `filters.period` — el estado
 * que ya asumía `clearFilters` —, porque ningún endpoint del tablero recibe
 * hoy un rango: /charts/income y /users/* calculan el mes en curso por su
 * cuenta. Quedan puestas porque el diseño las pide; para que filtren de
 * verdad hace falta que el gateway acepte `from`/`to`.
 */
const PERIODS = [
    { value: 'today', label: 'Hoy' },
    { value: 'week', label: 'Esta semana' },
    { value: 'month', label: 'Este mes' },
    { value: 'year', label: 'Este año' },
];

const DashboardFilters = ({
    filters,
    setFilters,
    countries = [],
    selectedCountry,
    onCountryChange,
    onClear
}) => {
    const { getData } = useDataFetch();

    // Obtener departamentos directamente
    const { data: departmentsResponse } = getData(
        ['departments'],
        '/address/provinces/by-country',
        {},
        { country_id: '6873173cf6b95077fc0f0c80' }
    );

    const departments = departmentsResponse?.data?.provinces || [];

    const { data: citiesResponse } = getData(
        ['cities', filters.department],
        '/address/cities/by-province',
        {},
        { province_id: filters.department || '' },
        {
            enabled: !!filters.department && filters.department !== ''
        }
    );

    const cities = citiesResponse?.data?.cities || [];

    const handleDepartmentChange = (e) => {
        setFilters({
            ...filters,
            department: e.target.value,
            city: ''
        });
    };

    const handleCityChange = (e) => {
        setFilters({
            ...filters,
            city: e.target.value
        });
    };

    return (
        <div className="ui-filterbar">

            {PERIODS.map((period) => (
                <button
                    key={period.value}
                    type="button"
                    className={`ui-pill${filters.period === period.value ? ' ui-pill--active' : ''}`}
                    onClick={() => setFilters({ ...filters, period: period.value })}
                >
                    {period.label}
                </button>
            ))}

            <span className="ui-filter-select" style={{ marginLeft: 6 }}>
                <i className="ri-earth-line" />
                <select
                    value={selectedCountry || ''}
                    onChange={(e) => onCountryChange?.(e.target.value)}
                    aria-label="País"
                >
                    {/*
                      Sin opción "Todos": /charts/growth-metrics exige countryId
                      y con el valor vacío la gráfica se queda sin consultar.
                    */}
                    <option value="" disabled>Selecciona un país</option>
                    {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                            {country.name}
                        </option>
                    ))}
                </select>
            </span>

            <span className="ui-filter-select">
                <i className="ri-map-pin-line" />
                <select
                    value={filters.department || ''}
                    onChange={handleDepartmentChange}
                    aria-label="Departamento"
                >
                    <option value="">Todos los departamentos</option>
                    {departments.map((department) => (
                        <option key={department.id} value={department.id}>
                            {department.name}
                        </option>
                    ))}
                </select>
            </span>

            <span className="ui-filter-select">
                <select
                    value={filters.city || ''}
                    onChange={handleCityChange}
                    disabled={!filters.department}
                    aria-label="Ciudad"
                >
                    <option value="">Todas las ciudades</option>
                    {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                            {city.name}
                        </option>
                    ))}
                </select>
            </span>

            <button type="button" className="ui-link" onClick={onClear}>
                Limpiar filtros
            </button>

        </div>
    );
};

export default DashboardFilters;
